import { render, staticRenderFns } from "./CallDetails.vue?vue&type=template&id=01497e8b&scoped=true&"
import script from "./CallDetails.vue?vue&type=script&lang=js&"
export * from "./CallDetails.vue?vue&type=script&lang=js&"
import style0 from "./CallDetails.vue?vue&type=style&index=0&id=01497e8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01497e8b",
  null
  
)

export default component.exports